import { useState } from 'react'

import { Box, Paper, Popper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import PremiumModal from './PremiumModal'
import UnlockPremiumButton from './UnlockPremiumButton'
import backgroundImage from './headerShape.svg'
import { UnlockPremiumAction } from './tracking'

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
  },
  header: {
    padding: theme.spacing(2),
    width: '100%',
    background: theme.palette.secondary.main,
    backgroundImage: `url("${backgroundImage}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: theme.palette.common.white,
    borderTopRightRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius,
  },
}))

export function PremiumActionsWrapper({
  enabled,
  children,
  trackingIdPlacement,
}: {
  enabled: boolean
  children: React.ReactElement
  trackingIdPlacement: UnlockPremiumAction
}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [modalOpen, setModalOpen] = useState(false)
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  if (enabled) {
    return children
  }
  return (
    <Box
      display="flex"
      gridGap={16}
      onMouseLeave={handlePopoverClose}
      onMouseEnter={handlePopoverOpen}
    >
      {children}
      <Popper
        open={open}
        anchorEl={anchorEl}
        style={{ zIndex: 2 }}
      >
        <Paper
          elevation={6}
          className={classes.paper}
        >
          <Box className={classes.header}>
            <Typography>
              Upgrade to access <br />
              premium features
            </Typography>
          </Box>
          <UnlockPremiumButton
            onClick={() => {
              setModalOpen(true)
              handlePopoverClose()
            }}
            trackingIdPlacement={trackingIdPlacement}
          />
        </Paper>
      </Popper>
      <PremiumModal
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false)
        }}
        trackingIdPlacement={trackingIdPlacement}
      />
    </Box>
  )
}
export default PremiumActionsWrapper
